import { NgModule } from '@angular/core';
import { MeetingTypesPipe } from '@meeting/pipes/meeting-types.pipe';
import { BoldTextPipe } from './bold-text.pipe';
import { CalculatePercentagePipe } from './calculate-percentage.pipe';
import { CapitalizeFirstPipe } from './capitalize-first.pipe';
import { ColonPipe } from './colon.pipe';
import { DateToNowPipe } from './date-to-now.pipe';
import { DatePipe } from './date.pipe';
import { DisableOptionPipe } from './disable-option.pipe';
import { HighlightTextPipe } from './highlight-text.pipe';
import { LocalizePipe } from './localize.pipe';
import { MarkdownPipe } from './markdown.pipe';
import { ModulePipe } from './module.pipe';
import { PermissionsPipe } from './permissions.pipe';
import { PluralPipe } from './plural.pipe';
import { SanitizeWhiteSpacePipe } from './sanitize-white-space';
import { UsernamePipe } from './username.pipe';

const PIPES = [
  MarkdownPipe,
  ColonPipe,
  CapitalizeFirstPipe,
  DatePipe,
  LocalizePipe,
  PluralPipe,
  UsernamePipe,
  DateToNowPipe,
  HighlightTextPipe,
  CalculatePercentagePipe,
  ModulePipe,
  PermissionsPipe,
  DisableOptionPipe,
  MeetingTypesPipe,
  SanitizeWhiteSpacePipe,
  BoldTextPipe,
];
@NgModule({
  declarations: [PIPES, PermissionsPipe],
  exports: [PIPES],
})
export class GlobalPipesModule {}
